__turbopack_context__.v({
  "desktop-only": "CorePeopleSearch-module-scss-module__05tB2a__desktop-only",
  "left-column": "CorePeopleSearch-module-scss-module__05tB2a__left-column",
  "main": "CorePeopleSearch-module-scss-module__05tB2a__main",
  "mobile-only": "CorePeopleSearch-module-scss-module__05tB2a__mobile-only",
  "no-active-filters-layout": "CorePeopleSearch-module-scss-module__05tB2a__no-active-filters-layout",
  "right-column": "CorePeopleSearch-module-scss-module__05tB2a__right-column",
});
